import { cathayFlexVideo } from './cathayFlexSources.js';

// The approved compositions share one canvas so changing scenes preserves layout.
const artwork = (file, label, caption, alt, revision = '') => ({
  src: `/assets/img/projects/${file}.webp${revision ? `?v=${revision}` : ''}`,
  smallSrc: `/assets/img/projects/${file}-800.webp${revision ? `?v=${revision}` : ''}`,
  label,
  caption,
  alt,
  width: 1600,
  height: 1180
});

export const projectShowcases = {
  cathayflex: {
    title: 'Cathay Flex',
    category: 'An airline flexibility marketplace',
    description: 'Cathay Flex is an airline-managed marketplace developed for the Cathay Pacific Hackathon. Travellers earn credits by accepting suitable changes or releasing unused services, then use them across services and journeys. AI interprets preferences, constrained optimisation finds compatible arrangements, and a transaction and settlement system coordinates the exchange.',
    scenes: [{
      kind: 'cathay-flex-film', label: 'Cathay Flex introduction',
      src: cathayFlexVideo.poster, smallSrc: cathayFlexVideo.poster,
      width: 1920, height: 1080,
      alt: 'Cathay Flex. Let your flexibility take you further.',
      caption: 'See how passenger flexibility creates value across journeys.',
    }],
  },
  slidepoise: {
    title: 'SlidePoise',
    defaultScene: 'Editorial example',
    category: 'Agentic Slide Generation',
    description: 'SlidePoise brings the visual freedom of image generation to editable PowerPoint. You work with an AI Agent on the argument and relationships between ideas, while image generation explores their visual composition beyond fixed templates. The Agent interprets the chosen design and combines that understanding with OpenCV measurements to rebuild it as editable slides.',
    scenes: [
      { ...artwork('slidepoise-editorial', 'Editorial example',
        'Five slides share a visual language. Text and original illustrations remain separate objects.',
        'Five editorial slides made with SlidePoise. An editable heading and a paper collage illustration appear as separate objects.', '20260911'), motion: 'slidepoise-editorial' },
      { ...artwork('slidepoise-consulting', 'Consulting example',
        'An evidence-led presentation with editable text, tables and a native PowerPoint chart.',
        'SlidePoise consulting example showing a complete slide, selected editable text and table, and a native chart with its data.', '20260911'), motion: 'slidepoise-consulting' }
    ]
  },
  searchstory: {
    title: 'AI × Self',
    defaultScene: 'Exploring the archive',
    category: 'An AI-driven personal archive',
    description: 'Visitors can ask AI a question about my work, ideas or experiences. AI connects material from this site into a View, an illustrated article that answers their question and includes the original work. Each View also becomes an exhibition visitors can walk through, and the Gallery brings shared exhibitions together.',
    scenes: [
      { ...artwork('archive-main-v22', 'Exploring the archive',
        'Questions bring original material into answers, composed readings and exhibitions.',
        'Search finds a passage, Ask gives an answer with a citation, and View composes articles and exhibitions. Three saved Views appear above The View Gallery’s architectural model and ticket.'), tabLabel: 'The archive', motion: 'main' },
      { ...artwork('archive-view-v25', 'A composed View',
        'AI connects original material around a visitor’s question, composing a View to read as an article or explore as an exhibition.',
        'Visitors bring different questions about Henry’s life, research and design. A question about what Henry’s memories reveal about him brings photographs, a reflection on identity and a travel globe into a View shown as an article and exhibition. A handwritten note explains how other people’s questions can reveal connections Henry would not have thought of.'), tabLabel: 'A View', motion: 'view' },
    ]
  }
};
